import {
  AutorenewOutlined,
  BeachAccessOutlined,
  LogoutOutlined,
  PersonOutlined,
  QuestionAnswerOutlined,
  SummarizeOutlined,
} from '@mui/icons-material';
import { Avatar, Button, Divider, Link, ListItemIcon, ListItemText, MenuItem, MenuList, Stack, Typography } from '@mui/material';
import packageJson from '../../../package.json';
import useNotification from '../../hooks/useNotification';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setFlyoutOpen, setItem } from '../../store/slices/menuSlice';
import { logout } from '../../store/thunks/authThunks';
import MenuUtils from '../../utils/MenuUtils';

const FlyoutMenuList = () => {
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();
  const { notifyContext } = useNotification();

  const appVersion = 'Version v ' + packageJson.version;
  const handleMeItemClick = (item: number) => {
    dispatch(setItem(item));
    dispatch(setFlyoutOpen(false));
  };

  const handleLogout = () => {
    dispatch(logout(undefined));
    dispatch(setFlyoutOpen(false));
  };

  /*
  Update service worker on new version
  */
  const updateServiceWorker = () => {
    // check if the browser supports service workers
    if ('serviceWorker' in navigator) {
      // first wait for the service worker to be ready
      navigator.serviceWorker.ready
        .then((registration) => {
          // then update the service worker and reload the page
          registration.unregister().then(() => {
            // clear all caches
            caches
              .keys()
              .then((cacheNames) => {
                return Promise.all(
                  cacheNames.map((cacheName) => {
                    return caches.delete(cacheName);
                  })
                );
              })
              .finally(() => {
                window.location.reload();
              });
          });
        })
        .catch((error) => {
          notifyContext.addNotification('Ops da hat was nicht geklappt!', 'error');
          console.error('Service Worker Error: ', error);
        });
    } else {
      notifyContext.addNotification('Es wurde kein Update gefunden', 'info');
    }
  };

  return (
    <>
      <Stack direction="column" justifyContent="space-between" alignItems="flex-start" sx={{ height: '100%' }}>
        <MenuList>
          <MenuItem onClick={() => handleMeItemClick(MenuUtils.Profile)} sx={{ justifyContent: 'center', pb: 6 }}>
            <Stack direction="column" justifyContent="center" alignItems="center" gap={0}>
              <Avatar alt={user?.displayName || ''} src={user?.photoURL || ''} sx={{ width: 56, height: 56 }} />
              <Typography variant="subtitle1">{user?.displayName}</Typography>
              <Typography variant="caption">{user?.email}</Typography>
            </Stack>
          </MenuItem>
          <MenuItem onClick={() => handleMeItemClick(MenuUtils.Profile)}>
            <ListItemIcon>
              <PersonOutlined />
            </ListItemIcon>
            <ListItemText>Mein Profil</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => handleMeItemClick(MenuUtils.Absence)}>
            <ListItemIcon>
              <BeachAccessOutlined />
            </ListItemIcon>
            <ListItemText>Meine Abwesenheiten</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => handleMeItemClick(MenuUtils.Report)}>
            <ListItemIcon>
              <SummarizeOutlined />
            </ListItemIcon>
            <ListItemText>Bericht erstellen</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => handleMeItemClick(MenuUtils.FAQ)}>
            <ListItemIcon>
              <QuestionAnswerOutlined />
            </ListItemIcon>
            <ListItemText>Fragen und Antworten</ListItemText>
          </MenuItem>
        </MenuList>

        <MenuList dense sx={{ width: '100%' }}>
          <MenuItem>
            <Button fullWidth variant="outlined" color="secondary" onClick={updateServiceWorker} startIcon={<AutorenewOutlined />}>
              App Update
            </Button>
          </MenuItem>

          <MenuItem>
            <Button fullWidth variant="contained" color="error" onClick={handleLogout} startIcon={<LogoutOutlined />}>
              Logout
            </Button>
          </MenuItem>
          <Divider sx={{ width: '100%' }} />
          <MenuItem onClick={() => handleMeItemClick(MenuUtils.Privacy)}>
            <ListItemText secondary="Datenschutz&shy;erkl&auml;rung" />
          </MenuItem>
          <MenuItem onClick={() => handleMeItemClick(MenuUtils.Terms)}>
            <ListItemText secondary="Impressum" />
          </MenuItem>
          <MenuItem href="https://github.com/flojud" component={Link}>
            <ListItemText secondary="Kontakt" />
          </MenuItem>
          <MenuItem>
            <ListItemText secondary={appVersion} />
          </MenuItem>
        </MenuList>
      </Stack>
    </>
  );
};
export default FlyoutMenuList;
